export const s3MediaBucket = () =>
  process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'uitest' ? `itrvl-${process.env.NODE_ENV}-media` : 'itrvl-dev-content';
